import { render } from "./ComHeader.vue?vue&type=template&id=18a9b477"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__